module.exports = __webpack_public_path__ + "static/devices-1-0e5d567850e1595855b83fd5120c59e3.svg";